// src/pages/Schedule/AdminSchedule.js
import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../lib/firebase";
import ScheduleBoard from "./ScheduleBoard";
import "./Schedule.css";

const GENERAL_CONFIG_REF = doc(db, "appConfig", "general");

export default function AdminSchedule({ readOnly = false }) {
  const [schedulePublished, setSchedulePublished] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function loadStatus() {
      try {
        setLoadingStatus(true);
        const snap = await getDoc(GENERAL_CONFIG_REF);
        const published = snap.exists() ? !!snap.data()?.schedulePublished : false;
        if (mounted) setSchedulePublished(published);
      } catch (err) {
        console.error("Failed to load schedulePublished:", err);
        if (mounted) setSchedulePublished(false);
      } finally {
        if (mounted) setLoadingStatus(false);
      }
    }

    loadStatus();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <>
      <div
        style={{
          margin: "12px 12px 0",
          padding: "12px 14px",
          border: "1px solid #e5e7eb",
          borderRadius: 12,
          background: loadingStatus
            ? "#f8fafc"
            : schedulePublished
            ? "#ecfdf5"
            : "#fff7ed",
          color: "#0f172a",
          fontWeight: 700,
        }}
      >
        Schedule Status:{" "}
        {loadingStatus ? "Loading…" : schedulePublished ? "Published" : "Unpublished"}
      </div>

      <ScheduleBoard readOnly={readOnly} />
    </>
  );
}